var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "blue-grey lighten-1 white--text subheading"
  }, [_c('v-avatar', {
    staticClass: "mt-1",
    attrs: {
      "color": "indigo darken-1",
      "size": "32"
    }
  }, [_c('span', {
    staticClass: "white--text headline"
  }, [_vm._v(_vm._s(_vm.avatar))])]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }